import { InboxComponent } from './../../layout/Inbox/Inbox.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CalendarComponent } from './calendar/calendar.component';
import { HomeComponent } from './home/home.component';
import { IndexComponent } from './index/index.component';
import { ComposeEmailComponent } from 'src/app/layout/Inbox/ComposeEmail/ComposeEmail.component';
import { InboxListComponent } from 'src/app/layout/Inbox/inboxList/inboxList.component';
import { MessageDetailsComponent } from 'src/app/layout/Inbox/MessageDetails/MessageDetails.component';
import { ReportEngineComponent } from '../report/report-engine/report-engine.component';
import { CreateCampaignComponent } from './create-campaign/create-campaign.component';
import { EmailsConfigurationComponent } from './emails-configuration/emails-configuration.component';
import { ApprovalDecisionReportComponent } from './approval-decision-report/approval-decision-report.component';
import { CheckoutSuccessComponent } from '../shoppingCart/checkout/checkout-success/checkout-success.component';
import { ReturnWizardComponent } from './return-wizard/return-wizard.component';

const routes: Routes = [
  {
    path: '',
    component: IndexComponent,
    data: {
      app: 'crm',
    },
    children: [
      {
        path: '',
        loadChildren: () =>
          import('src/app/layout/layout-routing.module').then(
            (m) => m.LayoutRoutingModule
          ),
      },
      {
        path: 'home',
        loadChildren: () =>
          import('../dashboard/dashboard-routing.module').then(
            (m) => m.DashboardRoutingModule
          ),
      },
      {
        path: 'calendar',
        component: CalendarComponent,
      },
      {
        path: 'create-campaign-wizard',
        component: CreateCampaignComponent,
      },
      {
        path: 'approval-decision-report',
        component: ApprovalDecisionReportComponent,
      },
      {
        path: 'return-wizard',
        component: ReturnWizardComponent,
      },
      {
        path: 'report-engine/:reportId',
        component: ReportEngineComponent,
      },
      {
        path: 'inbox',
        component: InboxComponent,
        children: [
          { path: '', redirectTo: 'inboxMail', pathMatch: 'full' },
          { path: 'Compose', component: ComposeEmailComponent },
          {
            path: 'inboxMail',
            component: InboxListComponent,
            children: [
              { path: 'Details/:id', component: MessageDetailsComponent },
            ],
          },
        ],
      },
      {
        path: 'shoppingCart',
        loadChildren: () =>
          import('../shoppingCart/shoppingCart.module').then(
            (m) => m.ShoppingCartModule
          ),
      },
      {
        path: 'payment',
        loadChildren: () =>
          import('../payment/payment.module').then((m) => m.PaymentModule),
      },
      {
        path: 'emails-configuration',
        component: EmailsConfigurationComponent,
      },
      {
        path: 'checkoutSuccess',
        component: CheckoutSuccessComponent
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CrmRoutingModule {}
